import { Box, styled } from '@ltvco/refresh-lib/theme';

export const AudioPlayerWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2),
    marginTop: 0,
  },
}));
